import React, { useState } from 'react';
import styles from './Navbar.module.css';
import { Link,useLocation  } from 'react-router-dom';
import logo from '../../assets/Logo.png'; 
import logoText from '../../assets/Logo-Text.png'; 

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.logoContainer}>
        <img 
          src={logo} 
          alt="CyberInn Logo" 
          className={styles.logoImage}
        />
        <img 
          src={logoText} 
          alt="CyberInn Logo" 
          className={styles.logoImageText}
        />
      </div>

      {/* Desktop Navigation */}
      <ul className={`${styles.navLinks} ${styles.desktopNav}`}>
        <li>
          <Link 
            to="/" 
            className={`${isActive('/') ? styles.active : ''}`}
          >
            Home
          </Link>
        </li>
        <li>
          <Link 
            to="/about" 
            className={`${isActive('/about') ? styles.active : ''}`}
          >
            About Us
          </Link>
        </li>
        <li>
          <Link 
            to="/courses" 
            className={`${isActive('/courses') || location.pathname.startsWith('/courses/') ? styles.active : ''}`}
          >
            Courses
          </Link>
        </li>
      </ul>

      {/* Mobile Hamburger Icon */}
      <button 
        className={`${styles.hamburger} ${isMenuOpen ? styles.open : ''}`}
        onClick={toggleMenu}
        aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        aria-expanded={isMenuOpen}
      >
        <span className={styles.line}></span>
        <span className={styles.line}></span>
        <span className={styles.line}></span>
      </button>

      {/* Mobile Navigation */}
      <div className={`${styles.mobileNav} ${isMenuOpen ? styles.open : ''}`}>
        <ul>
          <li>
            <Link 
              to="/" 
              className={`${isActive('/') ? styles.active : ''}`}
              onClick={toggleMenu}
            >
              Home
            </Link>
          </li>
          <li>
            <Link 
              to="/about" 
              className={`${isActive('/about') ? styles.active : ''}`}
              onClick={toggleMenu}
            >
              About Us
            </Link>
          </li>
          <li>
            <Link 
              to="/courses" 
              className={`${isActive('/courses') || location.pathname.startsWith('/courses/') ? styles.active : ''}`}
              onClick={toggleMenu}
            >
              Courses
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;